<template>
  <div>
    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="ComapnyName"
          lableText="Company Name"
          v-model="company.name"
          class="mt-3"
        />
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <b-form-file
          @change="readLogo"
          :state="Boolean(company.logo)"
          placeholder="Choose a Company Logo..."
          drop-placeholder="Drop file here..."
        ></b-form-file>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col>
        <GmapAutocomplete @place_changed="e=>$emit('place_changed',e)" class="mt-1 location-search"></GmapAutocomplete>
      </b-col>
    </b-row>-->
    <slot name="footer-button" :data="company"></slot>
  </div>
</template>
<script>
import cInput from "@/components/FormElements/CustomInput";
import Vue from "vue";

export default {
  name: "companyStepper",
  data() {
    return {
      company: {
        name: "",
        logo: ""
      }
    };
  },
  components: {
    cInput
  },
  methods: {
    readLogo(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.uploadImage(reader.result);
      };
      reader.onerror = err => {
        this.$toasted.error("Image not uploaded..please try again!");
      };
    },
    // upload images to the S3 bucket
    async uploadImage(image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) +
          Math.random()
            .toString(36)
            .substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant"
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then(res => {
          if (res) {
            this.clearCustomToast();
            this.company.logo = res.data.fileUrl;
          }
        })
        .catch(error => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    }
  },
  mounted() {}
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: 'Lato';
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}
[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #727cf5;
  color: white;
}
</style>
<style>
.custom-file-label {
  border-radius: 0px !important;
  border: 1px solid #dee2e6 !important;
  color: #dee2e6 !important;
}
</style>
